/**
 * @module common
 * @name mdFeelSuscriptionService
 * @type service
 * @description Servicio para aplicar lógica de suscripciones al programa de Massimo Dutti Feel
 */
(function () {
    'use strict';

    angular.module('itxApp.common').factory('mdFeelSuscriptionService', mdFeelSuscriptionService);

    mdFeelSuscriptionService.$inject = [
        '$http',
        '$q',
        'UserService',
        'ItxNewsletterSvc',
        'ItxStaticResourceSvc',
        'timestampSvc',
        'ItxLoaderFct',
        'crmService'
    ];

    function mdFeelSuscriptionService($http, $q, UserService, ItxNewsletterSvc, ItxStaticResourceSvc, timestampSvc, ItxLoaderFct, crmService) {
        var _this = this;

        _this.staticPath = {
            DEVELOPMENT: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PREPRU: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PRUSTG: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PRO: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            STAGE: `https://${inditex.iProxyHostStandard}/itxrest/2/`
        };

        _this.pathAlta = ItxStaticResourceSvc.getStatic() + '/media/2019/crm/web/';
        _this.timeStamp = timestampSvc.getTs();

        var service = {
            openCrmPopup: _openCrmPopup,
            registerCrm: _registerCrm
        };

        return service;

        /**
         * Función para registrar un usuario al programa Feel
         */
        function _registerCrm(model) {
            ItxLoaderFct.show();

            var deferred = $q.defer();
            var url = crmService.getUserBaseUrl() + '/crm';
            var headers = crmService.getHeaders();

            $http({
                method: 'POST',
                url: url,
                data: {},
                headers: headers,
                secure: false,
                params: { appId: inditex.iAppId }
            })
                .then(function () {
                    if (model.newsletterAccepted) {
                        ItxNewsletterSvc.subscribe(inditex.iUserJSON.email, model.sectionsSelected, 'web_alta_feel', true);
                    }
                    UserService.getCurrentUser().then(function () {
                        //Refrescamos el iUserJSON para el nuevo valor de crmAccepted
                        deferred.resolve();
                        ItxLoaderFct.hide();
                    });
                })
                .catch(function () {
                    console.error(_getErrorString('Error accepting CRM'));
                    deferred.reject({ err: 'Error accepting CRM' });
                    ItxLoaderFct.hide();
                });

            return deferred.promise;
        }

        /**
         * Función para abrir la ventana modal de registro en Massimo Dutti Feel
         */
        function _openCrmPopup() {
            window.location.hash = '#feel-join';
        }

        /**
         * Función para establecer el mensaje de error
         */
        function _getErrorString(message) {
            return 'CRM Service Error // ' + message;
        }
    }
})();
